import(/* webpackMode: "eager", webpackExports: ["useTranslation"] */ "/app/src/app/i18n/client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["getPromotionData"] */ "/app/src/libs/client/goApi/promotion/getPromotionData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/templates/FooterContent.tsx");
